export default __webpack_public_path__ + "static/media/kit_svg9.0a7aac3a.svg";